import apiService, { ApiService } from "../api-service.ts";


class SmartService {
    /**
     * api service helper.
     */
    private _apiService: ApiService;

    /**
     * instaniates AuditService;
     */
    constructor() {
        this._apiService = apiService;
    }

    public GetServices(data: any) {
        return this._apiService.get(`service/getAll?page=${data.page}`);
    }

    public SaveService(data:any) {
        return this._apiService.post(`service/create`,data);
    }

    public GetServiceById(id: number) {
        return this._apiService.get(`service/getById?id=${id}`);
    }

    public UpdateService(data:any) {
        return this._apiService.post(`service/update`,data);
    }

    public SaveCustomValues(data:any) {
        return this._apiService.post(`service/saveCustomValues`,data);
    }

    public GetCustomValues(id:number){
        return this._apiService.get(`service/getCustomValues?id=${id}`);
    }

    public GetServiceList(){
        return this._apiService.get(`service/getServices`);
    }

    
}

export default new SmartService();